import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/employee-activities/export-excel`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const exportExcel = {
  get: apiPathFunc(pathBase),
};
